<template>


  <div class="container">
    <div class="handle-box-search">




      <el-row class="head-search">

        <el-col :span="24" style="margin: 10px 0;">
          <span class="title">审核状态:</span>
          <el-radio-group v-model="search_data.status" size="small">
            <el-radio label="" border>
              全部</el-radio>
            <el-radio v-for="(item, index) in value_status_array" :key="index" :label="String(item.val)" border>
              {{ item.alias }}</el-radio>
          </el-radio-group>
        </el-col>

      </el-row>


      <el-button type="primary" icon="el-icon-search" @click="searchConsumerWalletCashLists">搜索</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>






    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">

            <div class="more-style">
              <el-form-item label="申请详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>
              <el-form-item label="审核详细时间:">
                <span>{{ props.row.verify_time.YmdHis }}</span>
              </el-form-item>
            </div>

            <el-form-item label="备注:">
              <span>{{ props.row.remarks }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" width="80">
      </el-table-column>


      <el-table-column prop="name" label="用户名称" width="150">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>用户编码: {{ scope.row.consumer.consumer_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.consumer.name }}
              </el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column prop="phone" label="手机号">
      </el-table-column>


      <el-table-column prop="name" label="银行卡号">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>唯一编码: {{ scope.row.consumer_bank_card.consumer_bank_card_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">
                {{ scope.row.consumer_bank_card.bank_card_no }}
              </el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>


      <el-table-column prop="amount" label="提现金额">
      </el-table-column>


      <el-table-column prop="time.Ymd" label="申请时间">
      </el-table-column>

      <el-table-column prop="verify_time.Ymd" label="审核时间">
      </el-table-column>


      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-button split-button type="primary"
            @click="consumerWalletCashToexamine_isShow = !consumerWalletCashToexamine_isShow; consumerWalletCashToexamine_children = scope.row.consumer_cash_code "
            trigger="click">

            审核提现


          </el-button>

        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 审核提现组件  -->
    <userWalletCashToexamine :isShow="consumerWalletCashToexamine_isShow" @onSubmit="consumerWalletCashLists"
      :data="consumerWalletCashToexamine_children"></userWalletCashToexamine>

  </div>


</template>

<script>
  var _this;
  import userWalletCashToexamine from './userWalletCashToexamine.vue';
  export default {
    components: {
      userWalletCashToexamine
    },
    data() {
      return {

        // 传入子组件的数据
        consumer_code_children: '',

        // 审核提现组件开关
        consumerWalletCashToexamine_isShow: false,

        // 审核提现组件传值
        consumerWalletCashToexamine_children: '',

        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: [],

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          consumer_code: '',
          status: '',
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;
      _this.consumerWalletCashLists();
    },

    methods: {
      searchConsumerWalletCashLists() {
        _this.search_data.page = 1;
        _this.consumerWalletCashLists();
      },
      // 搜索司机银行卡列表
      consumerWalletCashLists() {
        _this.$post(
            "/consumer/consumerCashLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = res.data[0].status.select_array;


          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.consumerWalletCashLists();

      },
      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].consumer_code);

        }
        _this.delconsumerSubmit_data.consumer_code_array = datalist;
      },

      statusChange(val) {
        console.log(val);

        _this.search_data.status = val.toString();

      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },
      untying(code) {
        console.log(code);

        _this.$post(
            "/consumer/delconsumerBankCardSubmit", {
              consumer_bank_card_code: code
            }
          )
          .then(res => {

            _this.$message.success(res.msg);
            _this.consumerWalletCashLists();

          }).catch((err) => {

          })
      }

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>